// extracted by mini-css-extract-plugin
export default {"movieCard":"MovieCard_movieCard__779Nd","movieImage":"MovieCard_movieImage__ViSwS"};